import React, { useState, useEffect } from "react";

export const TimeSlot = ({ arrSessList = [], setSelectedTimeSlot, selectedTimeSlot, setSelectedTimeSlotId, selectedTimeSlotId }) => {

    const setSelectedTimeSlotFun = (value, id) => {
        setSelectedTimeSlot(value);
        setSelectedTimeSlotId(id);
        console.log(selectedTimeSlotId);
        console.log(selectedTimeSlot);
    };

    return (
        <div className='time-slot pt-4'>
            {arrSessList.length > 0 ? (
                <div className='quantity-details'>
                    <h5>Time Slots</h5>
                </div>
            ) : null}

            <div className="input-radio-date">
                {arrSessList.map(
                    (sessitem, index) =>
                        <span key={index}>
                            {/* <input
                                type="radio"
                                className="btn-check"
                                name={sessitem.tick_sess_name}
                                value={sessitem.tick_sche_time_vals}
                                id={sessitem.tick_sche_time_id}
                                autoComplete="off"
                                defaultChecked={true}
                                onClick={() => setSelectedTimeSlotFun(sessitem.tick_sche_time_vals, sessitem.tick_sche_time_id)}
                            /> */}

                            <input
                                type="radio"
                                className="btn-check"
                                name={sessitem.tick_sess_name} // make sure all radios share the same name
                                value={sessitem.tick_sche_time_vals}
                                id={sessitem.tick_sche_time_id}
                                autoComplete="off"
                                checked={selectedTimeSlotId === sessitem.tick_sche_time_id}
                                onChange={() => setSelectedTimeSlotFun(sessitem.tick_sche_time_vals, sessitem.tick_sche_time_id)}
                            />


                            <label className="btn btn-secondary" htmlFor={sessitem.tick_sche_time_id}>
                                <span className="time">{sessitem.tick_sess_time}</span>
                            </label>
                        </span>
                )}
            </div>
        </div>
    )
}

